import type { JSX } from 'react';

export interface TrpcPanelProps {
  readonly echo: string | null;
  readonly loading: boolean;
  readonly error: string | null;
}

/**
 * Zeigt das Ergebnis von `system.ping` (AC-010).
 *
 * Reine Ansicht, wie `SessionPanel`: damit genuegt der vorhandene
 * Node-Renderer als Test, ohne DOM-Aufbau.
 *
 * Diese Komponente ist bewusst schmucklos. Sie belegt, dass ein typsicherer
 * Aufruf ueber die Workspace-Grenze funktioniert — echte Fachsichten kommen
 * mit den Frontend-Stories.
 */
export function TrpcPanel({ echo, loading, error }: TrpcPanelProps): JSX.Element {
  if (loading) {
    return <p>tRPC wird geprüft …</p>;
  }

  if (error !== null) {
    return <p role="alert">{error}</p>;
  }

  if (echo === null) {
    return <p>Kein tRPC-Ergebnis.</p>;
  }

  return (
    <p>
      tRPC-Antwort: <strong data-testid="trpc-echo">{echo}</strong>
    </p>
  );
}
